export var MxGraphNS;
(function (MxGraphNS) {
})(MxGraphNS || (MxGraphNS = {}));
//# sourceMappingURL=mxgraph-types.js.map